
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import moment from "moment";
import { downloadExcel } from "react-export-table-to-excel";
import FilterCard from "../../Component/transaction/filterCard";
import ViewTransaction from "../../Component/transaction/viewTransaction";
import { useAuth } from "../../Utils/Auth";
import TransactionService from '../../Services/TransactionService'
import { Button } from "react-bootstrap";
const UserStatement = () => {
    const auth = useAuth();
    const navigate = useNavigate()
    console.log("auth", auth)
    const customErrorHandler = () => { }
    function formatTransactionType() {

    }

    function toTitleCase() {

    }
    const [data, setData] = useState([]);
    const [paginationData, setPaginationData] = useState({
        page: 1,
        totalPages: 1,
        totalItems: 0,
        limit: 10,
    });
    const [isLoading, setIsLoading] = useState(false);
    const filterInitialState = {
        transactionType: '',
        admin: '',
        searchedAdmin: [],
        introducer: '',
        searchedIntroducer: [],
        bank: '',
        searchedBank: [],
        website: '',
        searchedWebsite: [],
        minAmount: '',
        maxAmount: '',
        transactionId: '',
        startDate: new Date() - 1 * 24 * 60 * 60 * 1000,
        endDate: new Date(),
        adminSerachQuery: '',
        introducerSerachQuery: '',
        bankSerachQuery: '',
        websiteSerachQuery: '',
        serachQuery: ''
    }
    const [filter, setFilter] = useState(filterInitialState)
    const [debouncedSearch, setDebouncedSearch] = useState('')
    const [itemPerPage, setItemPerPage] = useState(10)
    const [totalCharges, setTotalCharges] = useState(0)



    const tableHeaders = [
        { label: "Date & Time", field: "createdAt" },
        { label: "Amount", field: "amount" },
        { label: "Charge Percentage", field: "chargePercentage" },
        { label: "Charge Amount", field: "chargeAmount" },
        { label: "Bank", field: "bankName" },
        { label: "Website", field: "websiteName" },
        { label: "Bonus", field: "bonus" },
        { label: "Bank Charges", field: "bankCharges" },
        { label: "Txn Id", field: "txnId" },
        { label: "Txn Type", field: "transactionType" },
        { label: "Gateway", field: "paymentMethod" },
        { label: "Entry By", field: "subAdminName" },
        { label: "User", field: "userName" },
        { label: "Introducer", field: "introducerUserName" },
        { label: "Remarks", field: "remarks" },
    ];

    const fetchStatement = async (page) => {
        try {
            const payload = {
                transactionType: filter?.transactionType || "",
                bankName: filter?.bank || "",
                websiteName: filter?.website || "",
                subAdminId: filter?.admin || "",
                startDate: moment(filter.startDate).toDate(),
                endDate: moment(filter.endDate).toDate(),
                id: auth?.user?.introId
            };
            setIsLoading(true);
            const res = await TransactionService.allUserStatementReport(
                auth.user,
                payload,
                page || paginationData.page,
                itemPerPage,
            );
            console.log("res", res)
            const data = res?.data?.data?.transactions?.map((item) => ({
                ...item,
                createdAt: new Date(item.createdAt)
                    .toLocaleString("en-IN", {
                        timeZone: "Asia/Kolkata",
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                    })
                    .replace(/am|pm/i, (match) => match.toUpperCase()),
                //For Future Use
                //   updatedAt: new Date(item.updatedAt).toLocaleString("en-IN", {
                //     timeZone: "Asia/Kolkata",
                //     day: "2-digit",
                //     month: "2-digit",
                //     year: "numeric",
                //     hour: "2-digit",
                //     minute: "2-digit",
                //     second: "2-digit",
                //     hour12: true,
                //   }),
            }));
            // console.log(first)
            setData(data);
            console.log(data, '111')
            setTotalCharges(res.data.data.totalChargeAmount)
            console.log(res.data.data.totalChargeAmount, '000')

            if (res?.data?.pagination) {
                setPaginationData((state) => ({
                    ...state,
                    page: res?.data?.pagination?.page,
                    totalPages: res.data?.pagination?.totalPages,
                    totalItems: res.data?.pagination?.totalItems,
                    limit: res.data?.pagination?.limit,
                }));
            }
        } catch (err) {
            toTitleCase(customErrorHandler(err.message, "Something went wrong"));
        }
        setIsLoading(false);
    };

    useEffect(() => {
        fetchStatement();
    }, [filter?.transactionType, filter?.admin, filter.startDate, filter.endDate, filter.introducer, filter.bank, filter.website, itemPerPage]);
    // id, auth, select, subAdmin, page

    const startIndex = Math.min((paginationData.page - 1) * paginationData.limit + 1);
    const endIndex = Math.min(paginationData.page * paginationData.limit, paginationData.totalItems);


    const pageHandler = (selectedPage) => {
        // console.log(selectedPage);
        // setPaginationData((state) => ({
        //     ...state , 
        //     page : selectedPage
        // }));
        fetchStatement(selectedPage);
    };


    const handleDownloadExcel = () => {
        setIsLoading(true)
        const header = tableHeaders.map(header => header.label)
        const extractedData = data.map(row =>
            tableHeaders.map(header => row[header.field])
        ); const opt = auth.user?.userName;

        downloadExcel({
            fileName: `saveTableAsExcel - ${opt}`,
            sheet: "react-export-table-to-excel",
            tablePayload: {
                header,
                body: extractedData
            }
        });
        setIsLoading(false)
    }

    return (
        <div className="m-2" >
            <div className="d-flex justify-content-end">
                <Button variant="outline-secondary" className="" onClick={() => navigate("/welcome")}>
                    <i className="fas fa-arrow-left "></i>
                </Button>
            </div>

            <h6 className="d-flex justify-content-center mb-4">User Statement</h6>
            <FilterCard
                visibleFilters={{
                    transactionType: true,
                    subAdmin: false,
                    introducer: false,
                    bankName: false,
                    websites: false,
                    amountRange: false,
                    transactionId: false,
                    dateRange: true
                }}
                options={{
                    transactionTypes: ["Deposit", "Withdraw"],
                }}
                onFilterChange={() => { }}
                onFilterApply={() => { }}
                onFilterReset={() => setFilter(filterInitialState)}
                state={filter}
                setState={setFilter}
                setDebouncedSearch={setDebouncedSearch}
                debouncedSearch={debouncedSearch}
                fetchData={fetchStatement}
                handleDownloadExcel={handleDownloadExcel}
                isExcelDownloadable={data.length > 0}
                setItemPerPage={setItemPerPage}
                totalTransactionAmount={totalCharges}
            />

            <ViewTransaction
                headers={tableHeaders}
                data={data}
                // onDelete={}
                onSort={() => { }}
                sortField={""}
                sortDirection={true}
                onSearch={""}
                page={paginationData.page}
                totalPage={paginationData.totalPages}
                startIndex={startIndex}
                endIndex={endIndex}
                totalData={paginationData.totalItems}
                onPageChange={pageHandler}
            />
            {/* <FullScreenLoader show={isLoading} /> */}
        </div>

    );
};

export default UserStatement;
